var _ellipse, _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidenavUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 16.5,
    rx: 6,
    ry: 2.5,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 3,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.44824 13.2615C5.53677 13.7559 4.83404 14.3704 4.41992 15.0603C4.17335 15.1262 3.94663 15.2006 3.74316 15.282C3.34315 15.442 3.06939 15.614 2.9082 15.7664C2.75146 15.9146 2.75 15.9938 2.75 15.9998C2.75 16.0032 2.74886 16.0824 2.9082 16.2332C3.06936 16.3856 3.34309 16.5575 3.74316 16.7175C3.83148 16.7529 3.9247 16.7855 4.02148 16.8181C4.09993 17.4495 4.40927 18.044 4.90332 18.5769C4.26774 18.4678 3.6857 18.3102 3.18555 18.1101C2.68108 17.9083 2.22267 17.649 1.87793 17.323C1.53154 16.9954 1.25 16.5485 1.25 15.9998C1.25008 15.4511 1.53154 15.0041 1.87793 14.6765C2.22267 14.3506 2.68111 14.0912 3.18555 13.8894C4.06941 13.5359 5.20855 13.3128 6.44824 13.2615Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5516 13.2615C18.7913 13.3128 19.9305 13.5359 20.8143 13.8894C21.3187 14.0912 21.7772 14.3506 22.1219 14.6765C22.4683 15.0041 22.7498 15.4511 22.7499 15.9998C22.7499 16.5486 22.4684 16.9954 22.1219 17.323C21.7772 17.649 21.3188 17.9083 20.8143 18.1101C20.3139 18.3103 19.7316 18.4678 19.0956 18.5769C19.5899 18.0439 19.8989 17.4496 19.9774 16.8181C20.0745 16.7854 20.1681 16.753 20.2567 16.7175C20.6568 16.5575 20.9305 16.3856 21.0917 16.2332C21.2511 16.0823 21.2499 16.0032 21.2499 15.9998C21.2499 15.9938 21.2484 15.9146 21.0917 15.7664C20.9305 15.614 20.6567 15.442 20.2567 15.282C20.053 15.2005 19.8259 15.1262 19.579 15.0603C19.1648 14.3706 18.4629 13.7558 17.5516 13.2615Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9997 6.25C18.5185 6.25 19.7497 7.48122 19.7497 9C19.7497 10.5188 18.5185 11.75 16.9997 11.75C16.5141 11.7499 16.0587 11.6223 15.6628 11.4014C16.0058 11.0321 16.2937 10.6114 16.5134 10.1514C16.6629 10.2146 16.8271 10.25 16.9997 10.25C17.6901 10.25 18.2497 9.69036 18.2497 9C18.2497 8.30964 17.6901 7.75 16.9997 7.75C16.9977 7.75 16.9958 7.74999 16.9938 7.75C16.9683 7.23137 16.8629 6.73384 16.6911 6.26855C16.7925 6.25722 16.8953 6.25001 16.9997 6.25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6.25C7.10405 6.25 7.20657 6.2573 7.30762 6.26855C7.13591 6.73372 7.03139 7.23152 7.00586 7.75C7.00391 7.74999 7.00195 7.75 7 7.75C6.30964 7.75 5.75 8.30964 5.75 9C5.75 9.69036 6.30964 10.25 7 10.25C7.17225 10.25 7.33604 10.2144 7.48535 10.1514C7.70493 10.6113 7.99302 11.0321 8.33594 11.4014C7.94011 11.622 7.48536 11.75 7 11.75C5.48122 11.75 4.25 10.5188 4.25 9C4.25 7.48122 5.48122 6.25 7 6.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavUsers);
export default __webpack_public_path__ + "static/media/sidenav-users.9496a8471c4a10a753f700d75d1a90cf.svg";
export { ForwardRef as ReactComponent };